import React from "react";
import { MessageDescriptor, useIntl } from "react-intl";

import {
	LeafNode,
	LocalizedLeafNode,
	LocalizedNode,
	LocalizedParentNode,
	Node,
	ParentNode
} from "src/modules/shared/form-explorer/types";
import { isRawParentNode } from "src/modules/shared/form-explorer/utils";

export function useLocalizedNodes(nodes: Node[]): LocalizedNode[] {
	const { formatMessage } = useIntl();
	return React.useMemo(
		() => nodes.map(node => formatNode(formatMessage, node)),
		[nodes, formatMessage]
	);
}

function formatNode(
	formatMessage: (message: MessageDescriptor) => string,
	node: Node
): LocalizedNode {
	return isRawParentNode(node)
		? formatParentNode(formatMessage, node)
		: formatLeafNode(formatMessage, node);
}

function formatParentNode(
	formatMessage: (message: MessageDescriptor) => string,
	node: ParentNode
): LocalizedParentNode {
	return {
		...node,
		isOpen: false,
		value: { ...node.value, title: formatMessage(node.value.title) },
		children: node.children.map(node => formatNode(formatMessage, node))
	};
}

function formatLeafNode(
	formatMessage: (message: MessageDescriptor) => string,
	node: LeafNode
): LocalizedLeafNode {
	return {
		...node,
		value: { ...node.value, title: formatMessage(node.value.title) }
	};
}
